import React, { useState, useEffect } from "react";
import { IoSaveSharp } from "react-icons/io5";

// API base URL -- update for deployment
const API_BASE = "https://wa-api.globebot.io/auth";

// Hardcoded data for RCS
const HARDCODED_RCS_ROWS = [
  {
    country: "IN",
    countryInfo: "(91) INDIA",
    channel_type: "RCS",
    myRatePerUnit: 0.1200,
  },
];

// Hardcoded for now, replace with actual user ID logic as needed
// const user_id = 1;
const SERVICE_TYPE = "RCS";

function ManageuserforRCS({user_id}) {
  // Array of objects: [...{country, countryInfo, channel_type, myRatePerUnit, sellingRatePerUnit, id/null}]
  const [userRates, setUserRates] = useState(
    HARDCODED_RCS_ROWS.map((row) => ({
      ...row,
      sellingRatePerUnit: "", // will set to API value after fetch
      id: null, // backend record ID if exists
    }))
  );
  const [marginType, setMarginType] = useState("");
  const [marginOnPrice, setMarginOnPrice] = useState(0.03);
  const [percentOnPrice, setPercentOnPrice] = useState(0.03);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // Utility to get Selling Rate
  function getSellingRate(myRate, marginType, marginValue, percentValue, apiDefaultSellingRate) {
    if (marginType === "MarginOnPrice") {
      return Number((myRate + marginValue).toFixed(4));
    } else if (marginType === "PercentOnPrice") {
      return Number((myRate + (myRate * percentValue) / 100).toFixed(4));
    }
    // If not selected, return the API selling rate if it exists, else fallback to blank
    return apiDefaultSellingRate !== undefined && apiDefaultSellingRate !== "" 
      ? Number(apiDefaultSellingRate).toFixed(4) 
      : "";
  }

  // On mount, attempt to fetch existing rates for this user/countries/service_type/channel_type
  useEffect(() => {
    setLoading(true);
    fetch(
      `${API_BASE}/user_rates?user_id=${user_id}&service_type=${SERVICE_TYPE}`
    )
      .then((resp) => resp.json())
      .then((backendRows) => {
        // Overlay backend record (if found for same country/channel_type/user/service_type)
        const updatedRates = HARDCODED_RCS_ROWS.map((row) => {
          const rec = backendRows.find(
            (r) =>
              String(r.user_id) === String(user_id) &&
              r.country === row.country &&
              r.channel_type === row.channel_type &&
              r.service_type === SERVICE_TYPE
          );
          return {
            ...row,
            id: rec ? rec.id : null,
            myRatePerUnit:
              rec && rec.My_Rate !== undefined
                ? Number(rec.My_Rate)
                : row.myRatePerUnit,
            sellingRatePerUnit:
              rec && rec.Selling_Rate !== undefined
                ? Number(rec.Selling_Rate)
                : "", // Store API value, will use as default in table
          };
        });
        setUserRates(updatedRates);
      })
      .catch((e) => {
        setUserRates(
          HARDCODED_RCS_ROWS.map((row) => ({
            ...row,
            sellingRatePerUnit: "",
            id: null,
          }))
        );
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async () => {
    if (marginType !== "MarginOnPrice" && marginType !== "PercentOnPrice") {
      alert("Select MarginType");
      return;
    }
    setSubmitting(true);

    // Map with correct selling rates
    const finalData = userRates.map((row) => {
      let sellingRate = getSellingRate(
        row.myRatePerUnit,
        marginType,
        marginOnPrice,
        percentOnPrice
      );
      return {
        ...row,
        sellingRatePerUnit: sellingRate,
      };
    });

    for (let record of finalData) {
      // Build payload fields for API
      // You must match backend's requirements: user_id, service_type, country, channel_type, My_Rate, Selling_Rate
      const payload = {
        user_id,
        service_type: SERVICE_TYPE,
        country: record.country,
        channel_type: record.channel_type,
        My_Rate: record.myRatePerUnit,
        Selling_Rate: record.sellingRatePerUnit,
      };
      try {
        if (record.id) {
          // Update existing
          const res = await fetch(
            `${API_BASE}/user_rates/${record.id}`,
            {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            }
          );
          if (!res.ok) throw new Error("Failed to update user rate");
        } else {
          // Create new
          const res = await fetch(`${API_BASE}/user_rates`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
          if (!res.ok) throw new Error("Failed to create user rate");
        }
      } catch (error) {
        alert("Submission error for " + record.countryInfo);
      }
    }

    // Force reload from backend to refresh saved
    setLoading(true);
    fetch(
      `${API_BASE}/user_rates?user_id=${user_id}&service_type=${SERVICE_TYPE}`
    )
      .then((resp) => resp.json())
      .then((backendRows) => {
        const updatedRates = HARDCODED_RCS_ROWS.map((row) => {
          const rec = backendRows.find(
            (r) =>
              String(r.user_id) === String(user_id) &&
              r.country === row.country &&
              r.channel_type === row.channel_type &&
              r.service_type === SERVICE_TYPE
          );
          return {
            ...row,
            id: rec ? rec.id : null,
            myRatePerUnit:
              rec && rec.My_Rate !== undefined
                ? Number(rec.My_Rate)
                : row.myRatePerUnit,
            sellingRatePerUnit:
              rec && rec.Selling_Rate !== undefined
                ? Number(rec.Selling_Rate)
                : "",
          };
        });
        setUserRates(updatedRates);
        alert("Rates Saved!");
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <div className="w-[100%] ">
        <div className="w-[100%] flex gap-2">
          <div className="flex flex-col gap-2">
            <label
              className="text-[#000] text-[12px] font-semibold dark:text-[#fff]"
              htmlFor=""
            >
              Margin Type
            </label>
            <select
              value={marginType}
              onChange={(e) => setMarginType(e.target.value)}
              className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
              name=""
              id=""
            >
              <option value="">Select Margin Type</option>
              <option value="MarginOnPrice">Margin On Price</option>
              <option value="PercentOnPrice">Percent On Price</option>
              {/* <option value="FixedPrice">Fixed Price</option> */}
            </select>
          </div>

          {marginType === "FixedPrice" ? (
            ""
          ) : (
            <div className="flex flex-col gap-2">
              <label
                className="text-[#000] text-[12px] font-semibold dark:text-[#fff]"
                htmlFor=""
              >
                {marginType === "MarginOnPrice"
                  ? "Margin On Price"
                  : "Percent On Price (%)"}
              </label>
              <input
                type="number"
                name=""
                id=""
                className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                value={
                  marginType === "MarginOnPrice"
                    ? marginOnPrice
                    : percentOnPrice
                }
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (marginType === "MarginOnPrice") {
                    setMarginOnPrice(value);
                  } else {
                    setPercentOnPrice(value);
                  }
                }}
                step="0.01"
                min="0.01"
              />
            </div>
          )}
        </div>
        <div className="w-[100%] flex justify-end mt-2">
          <span className="text-[#858c97] text-[12px] ">
            Selling price can not be set{" "}
            <span className="text-red-600">less than 50%</span> of your cost
            price
          </span>
        </div>
        <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] relative mt-1 ">
          <thead className="">
            <tr className="text-left text-sm font-semibold text-gray-700 bg-[#f6f9fc]">
              <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6] ">
                <div className="flex justify-between items-center gap-2">
                  <span className="text-[11px] text-[#576071] dark:text-[#fff]">
                    Country Info
                  </span>
                </div>
              </th>
              <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6] ">
                <div className="flex justify-between items-center gap-2">
                  <span className="text-[11px] text-[#576071] dark:text-[#fff]">
                    Channel Type
                  </span>
                </div>
              </th>
              <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6] ">
                <div className="flex justify-between items-center gap-2">
                  <span className="text-[11px] text-[#576071] dark:text-[#fff]">
                    My Rate / Unit
                  </span>
                </div>
              </th>
              <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6] ">
                <div className="flex justify-between items-center gap-2">
                  <span className="text-[11px] text-[#576071] dark:text-[#fff]">
                    Selling Rate / Unit
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {userRates.length > 0 ? (
              userRates.map((user, index) => (
                <tr key={index}>
                  <td className="p-1 text-[11px] cursor-pointer border-[1px] border-[#dee2e6]">
                    {user.countryInfo}
                  </td>
                  <td className="p-1 cursor-pointer border-[1px] border-[#dee2e6] text-[11px]">
                    {user.channel_type}
                  </td>
                  <td className="p-1 cursor-pointer border-[1px] border-[#dee2e6] text-[#3f7fca] text-[11px]">
                    {user.myRatePerUnit}
                  </td>
                  <td className="p-1 cursor-pointer border-[1px] border-[#dee2e6] text-[11px]">
                    {marginType === "MarginOnPrice" || marginType === "PercentOnPrice"
                      ? getSellingRate(
                          user.myRatePerUnit,
                          marginType,
                          marginOnPrice,
                          percentOnPrice
                        ).toFixed(4)
                      : (
                          user.sellingRatePerUnit !== undefined && user.sellingRatePerUnit !== ""
                            ? Number(user.sellingRatePerUnit).toFixed(4)
                            : ""
                        )
                    }
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center text-gray-500 dark:bg-[#121519]">
                <td colSpan="4" className="p-1 text-[11px]">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="w-[100%] flex justify-end mt-2">
          <button
            onClick={handleSubmit}
            className="flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2  gap-2 hover:bg-[#37715d] hover:text-[#fff] text-[#37715d] w-full sm:w-auto"
            disabled={loading || submitting}
          >
            <span className="text-[12px] font-bold flex items-center gap-2">
              {" "}
              <IoSaveSharp />
              {submitting ? "Saving..." : "Save"}
            </span>
          </button>
        </div>
      </div>
    </>
  );
}

export default ManageuserforRCS;
